<template>
  <VRow no-gutters class="pb-2">
    <span
      class="text-secondary text-uppercase subheader font-weight-bold"
    >
      {{ text }}
    </span>
  </VRow>
</template>


<script setup lang="ts">
defineProps<{
  text: string
}>()

</script>

<style lang="scss">

</style>
